import { render, staticRenderFns } from "./VueSelectpicker.vue?vue&type=template&id=2e245f7a"
import script from "./VueSelectpicker.vue?vue&type=script&lang=js"
export * from "./VueSelectpicker.vue?vue&type=script&lang=js"
import style0 from "./VueSelectpicker.vue?vue&type=style&index=0&id=2e245f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports